import { createSliceSelectors } from '../utils'

const DeviceSelectors = createSliceSelectors('device', [
    'isMobileLandscapeModeEnabled',
    'isDesktopPlatform',
    'isInIframe',
    'isGyroscopeEnabled',
    'isDeviceOrientationSupported',
    'isDeviceMobile',
    'isDeviceIPhone',
    'isDeviceAndroid',
    'isDeviceTablet',
    'isDeviceIOS',
    'isDeviceOculus',
    'isLandscape',
    'viewportWidth',
    'viewportHeight',
    'appVersion',
    'deviceGrade',
])

export default DeviceSelectors
